export default function Footer() {
  return (
    <footer className="site-footer">
      <span>© 2026 JASMINE LAU</span>
      <span>San Francisco</span>
      <span>California</span>
    </footer>
  );
}